(function () {
  'use strict';

  function formatMoney(cents) {
    var format = window.kaliMoneyFormat || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withThousands = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var noDecimals = withThousands;
    var withComma = withThousands + ',' + parts[1];
    return format
      .replace(/\{\{\s*amount\s*\}\}/, withComma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma);
  }

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var kaliGallerySelect = function () {};
  var kaliUpsellIntercept = null;
  var kaliUpsellModals = {};

  var toastEl = qs('[data-kali-toast]');
  var toastTimer;
  function showToast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('is-visible');
    }, 2400);
  }

  /* ---------- Reveal animations ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var header = qs('[data-kali-header]');
    setTimeout(function () { if (header) header.classList.add('is-visible'); }, 60);
    qsa('[data-kali-fade]').forEach(function (el, i) {
      setTimeout(function () { el.classList.add('is-visible'); }, 120 + i * 40);
    });

    var footer = qs('[data-kali-footer-fade-root]');
    if (footer && 'IntersectionObserver' in window) {
      var footerFadeTargets = qsa('[data-kali-footer-fade]', footer);
      var obs = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          footerFadeTargets.forEach(function (el) { el.classList.add('is-visible'); });
          obs.disconnect();
        }
      }, { threshold: 0.15 });
      obs.observe(footer);
      setTimeout(function () {
        footerFadeTargets.forEach(function (el) { el.classList.add('is-visible'); });
      }, 4000);
    }

    var featuresRoot = qs('[data-kali-features-root]');
    if (featuresRoot) {
      if ('IntersectionObserver' in window) {
        var featuresObs = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            featuresRoot.classList.add('is-visible');
            featuresObs.disconnect();
          }
        }, { threshold: 0.3 });
        featuresObs.observe(featuresRoot);
        setTimeout(function () { featuresRoot.classList.add('is-visible'); }, 4000);
      } else {
        featuresRoot.classList.add('is-visible');
      }
    }
  });

  /* ---------- Nav active state on scroll ---------- */
  (function nav() {
    var links = qsa('[data-kali-nav-link]');
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        var targetSel = link.getAttribute('data-kali-nav-link');
        if (!targetSel) return;
        var target = qs(targetSel);
        if (target) {
          e.preventDefault();
          var top = target.getBoundingClientRect().top + window.scrollY - 24;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });
  })();

  /* ---------- Nav submenus (dropdown) ---------- */
  (function navDropdowns() {
    var dropdowns = qsa('[data-kali-dropdown]');
    if (!dropdowns.length) return;

    function closeAll(except) {
      dropdowns.forEach(function (dd) {
        if (dd === except) return;
        dd.classList.remove('is-open');
        var t = qs('[data-kali-dropdown-toggle]', dd);
        if (t) t.setAttribute('aria-expanded', 'false');
      });
    }

    dropdowns.forEach(function (dd) {
      var toggle = qs('[data-kali-dropdown-toggle]', dd);
      if (!toggle) return;
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = dd.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        closeAll(dd);
      });
    });

    document.addEventListener('click', function (e) {
      dropdowns.forEach(function (dd) {
        if (!dd.contains(e.target)) {
          dd.classList.remove('is-open');
          var t = qs('[data-kali-dropdown-toggle]', dd);
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll();
    });
  })();

  /* ---------- Mobile nav toggle ---------- */
  (function mobileNav() {
    var toggle = qs('[data-kali-nav-toggle]');
    var nav = qs('[data-kali-nav]');
    if (!toggle || !nav) return;

    function close() {
      toggle.classList.remove('is-active');
      toggle.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
    }

    function toggleOpen() {
      var isOpen = nav.classList.toggle('is-open');
      toggle.classList.toggle('is-active', isOpen);
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      toggleOpen();
    });

    qsa('[data-kali-nav-item]', nav).forEach(function (link) {
      link.addEventListener('click', close);
    });

    document.addEventListener('click', function (e) {
      if (!nav.classList.contains('is-open')) return;
      if (nav.contains(e.target) || toggle.contains(e.target)) return;
      close();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 1024) close();
    });
  })();

  /* ---------- Nav slogans typewriter ---------- */
  (function slogans() {
    var root = qs('[data-kali-slogans]');
    if (!root) return;
    var textEl = qs('[data-kali-slogan-text]', root);
    if (!textEl) return;
    var list;
    try { list = JSON.parse(root.getAttribute('data-kali-slogans') || '[]'); } catch (e) { list = []; }
    list = list.filter(function (s) { return s && s.trim(); });
    if (!list.length) return;

    var phraseIndex = 0;
    var charIndex = 0;
    var deleting = false;
    var timer;

    function tick() {
      if (document.hidden) {
        timer = setTimeout(tick, 250);
        return;
      }
      var phrase = list[phraseIndex];
      if (!deleting) {
        charIndex++;
        textEl.textContent = phrase.slice(0, charIndex);
        if (charIndex === phrase.length) {
          deleting = true;
          timer = setTimeout(tick, 1800);
          return;
        }
        timer = setTimeout(tick, 70);
      } else {
        charIndex--;
        textEl.textContent = phrase.slice(0, charIndex);
        if (charIndex === 0) {
          deleting = false;
          phraseIndex = (phraseIndex + 1) % list.length;
          timer = setTimeout(tick, 300);
          return;
        }
        timer = setTimeout(tick, 35);
      }
    }

    tick();
  })();

  /* ---------- Colecciones grid: tilt hover ---------- */
  (function coleccionesTilt() {
    if (!qs('.kali-colecciones-card')) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!window.matchMedia('(hover: hover)').matches) return;

    var cur = null;

    function ring(el) {
      var n = el.querySelector('.kali-colecciones-ring');
      if (!n) {
        n = document.createElement('span');
        n.className = 'kali-colecciones-ring';
        n.style.cssText = 'position:absolute;inset:0;pointer-events:none;opacity:0;transition:opacity .35s;border-radius:inherit;box-shadow:inset 0 0 0 2px rgba(255,255,255,.55)';
        el.appendChild(n);
      }
      return n;
    }

    function reset(el) {
      el.style.transition = 'transform .55s cubic-bezier(.2,.7,.2,1), box-shadow .5s';
      el.style.transform = '';
      el.style.boxShadow = '';
      el.style.zIndex = '';
      var r = el.querySelector('.kali-colecciones-ring');
      if (r) r.style.opacity = '0';
    }

    document.addEventListener('pointermove', function (e) {
      var el = e.target.closest ? e.target.closest('.kali-colecciones-card') : null;
      if (cur && cur !== el) reset(cur);
      if (!el) { cur = null; return; }
      cur = el;
      var r = el.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width;
      var py = (e.clientY - r.top) / r.height;
      el.style.transition = 'transform .1s linear, box-shadow .3s';
      el.style.transform = 'perspective(1100px) rotateY(' + ((px - 0.5) * 10).toFixed(2) + 'deg) rotateX(' + ((0.5 - py) * 10).toFixed(2) + 'deg) translateY(-8px) scale(1.025)';
      el.style.boxShadow = '0 34px 64px -26px rgba(0,0,0,.55)';
      el.style.zIndex = '5';
      ring(el).style.opacity = '1';
    }, true);

    document.addEventListener('pointerleave', function () {
      if (cur) reset(cur);
      cur = null;
    }, true);
  })();

  /* ---------- Gallery ---------- */
  (function gallery() {
    var mains = qsa('[data-kali-main-photo]');
    var thumbs = qsa('[data-kali-thumb]');
    if (!mains.length) return;

    // Non-first photos ship with data-src/data-srcset (see kali-main-product.liquid).
    function hydrate(img) {
      if (!img || !img.hasAttribute('data-src')) return;
      img.setAttribute('srcset', img.getAttribute('data-srcset'));
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }

    function select(index) {
      hydrate(mains[index]);
      hydrate(mains[Number(index) + 1]);
      mains.forEach(function (img) {
        img.classList.toggle('is-active', img.getAttribute('data-kali-main-photo') === String(index));
      });
      thumbs.forEach(function (t) {
        var active = t.getAttribute('data-kali-thumb') === String(index);
        qs('.kali-thumb-img-wrap', t).classList.toggle('is-active', active);
        qs('.kali-thumb-label', t).classList.toggle('is-active', active);
      });
    }

    // Móvil: contador de fotos, tira de miniaturas que sigue a la foto elegida y deslizar para cambiar.
    var current = 0;
    var countEl = qs('[data-kali-photo-count]');
    var stripEl = qs('.kali-thumb-grid');
    var baseSelect = select;
    // Fotos marcadas [pc] / [movil] en el alt: cada dispositivo ve solo las suyas.
    var mobileMQ = window.matchMedia('(max-width: 719px)');
    function deviceOk(i) {
      var d = mains[i] && mains[i].getAttribute('data-kali-device');
      return !d || d === (mobileMQ.matches ? 'movil' : 'pc');
    }
    function resolveIndex(index) {
      index = Number(index);
      if (deviceOk(index)) return index;
      var pair = mains[index].getAttribute('data-kali-pair');
      for (var i = 0; i < mains.length; i++) {
        if (mains[i].getAttribute('data-kali-pair') === pair && mains[i].getAttribute('data-kali-device') && deviceOk(i)) return i;
      }
      return index;
    }
    select = function (index) {
      index = resolveIndex(index);
      baseSelect(index);
      current = Number(index);
      if (countEl) countEl.textContent = (current + 1) + ' / ' + mains.length;
      var active = thumbs[current];
      if (stripEl && active && stripEl.scrollWidth > stripEl.clientWidth) {
        stripEl.scrollTo({ left: active.offsetLeft - (stripEl.clientWidth - active.offsetWidth) / 2, behavior: 'smooth' });
      }
    };

    var viewEl = qs('[data-kali-gallery-view]');
    if (viewEl && mains.length > 1) {
      var sx = 0, sy = 0;
      viewEl.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      viewEl.addEventListener('touchend', function (e) {
        var t = e.changedTouches[0];
        var dx = t.clientX - sx, dy = t.clientY - sy;
        if (window.innerWidth >= 720 || Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.5) return;
        var step = dx < 0 ? 1 : -1, n = current;
        for (var k = 0; k < mains.length; k++) {
          n = (n + step + mains.length) % mains.length;
          if (deviceOk(n)) break;
        }
        select(n);
      }, { passive: true });
    }

    kaliGallerySelect = select;
    window.kaliGallery = { select: select };

    // Celular: la foto marcada [movil] es la que se muestra primero.
    if (mobileMQ.matches) {
      for (var mi = 0; mi < mains.length; mi++) {
        if (mains[mi].hasAttribute('data-kali-movil')) { if (mi > 0) select(mi); break; }
      }
    } else {
      // Escritorio: si la primera foto es de móvil y tiene pareja [pc], se muestra la de escritorio.
      var firstPc = 0;
      for (var pi = 0; pi < mains.length; pi++) {
        if (mains[pi].getAttribute('data-kali-device') === 'pc') { firstPc = pi; break; }
      }
      select(firstPc);
    }

    // Warm up photo #2 once the page is idle so the first swipe/tap is instant.
    var warm = function () { hydrate(mains[1]); };
    if ('requestIdleCallback' in window) requestIdleCallback(warm, { timeout: 4000 });
    else setTimeout(warm, 3000);

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var index = t.getAttribute('data-kali-thumb');
        select(index);
        var mainImg = qs('[data-kali-main-photo="' + index + '"]');
        if (mainImg) mainImg.click();
      });
    });
  })();

  /* ---------- 360° spin viewer(s) ---------- */
  (function spin() {
    function initSpinRotation(spinView) {
      var framesWrap = qs('[data-kali-spin-frames]', spinView);
      var degreeEl = qs('[data-kali-spin-degree]', spinView);
      if (!framesWrap) return;

      var frames = qsa('[data-kali-spin-frame]', framesWrap);
      var frameCount = frames.length;
      if (!frameCount) return;
      var current = 0;
      var dragging = false;
      var lastX = 0;
      var accum = 0;
      var PX_PER_FRAME = 30;

      function showFrame(index) {
        current = ((index % frameCount) + frameCount) % frameCount;
        frames.forEach(function (img) {
          img.classList.toggle('is-active', img.getAttribute('data-kali-spin-frame') === String(current));
        });
        var degrees = Math.round((current * 360) / frameCount);
        if (degreeEl) degreeEl.textContent = degrees + '°';
        spinView.setAttribute('aria-valuenow', degrees);
      }

      function dragStart(x) {
        dragging = true;
        lastX = x;
        accum = 0;
        spinView.classList.add('is-dragging');
      }
      function dragMove(x) {
        if (!dragging) return;
        var delta = x - lastX;
        lastX = x;
        accum += delta;
        while (accum >= PX_PER_FRAME) { showFrame(current - 1); accum -= PX_PER_FRAME; }
        while (accum <= -PX_PER_FRAME) { showFrame(current + 1); accum += PX_PER_FRAME; }
      }
      function dragEnd() {
        dragging = false;
        spinView.classList.remove('is-dragging');
      }

      spinView.addEventListener('mousedown', function (e) { dragStart(e.clientX); });
      window.addEventListener('mousemove', function (e) { dragMove(e.clientX); });
      window.addEventListener('mouseup', dragEnd);

      spinView.addEventListener('touchstart', function (e) { dragStart(e.touches[0].clientX); }, { passive: true });
      spinView.addEventListener('touchmove', function (e) { dragMove(e.touches[0].clientX); }, { passive: true });
      spinView.addEventListener('touchend', dragEnd);

      spinView.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') {
          e.preventDefault();
          showFrame(current - 1);
        } else if (e.key === 'ArrowRight') {
          e.preventDefault();
          showFrame(current + 1);
        }
      });
    }

    qsa('[data-kali-spin-view]').forEach(initSpinRotation);

    /* Toggle between the main gallery photo and its inline 360° view */
    var galleryView = qs('[data-kali-gallery-view]');
    var gallerySpinView = qs('[data-kali-spin-view]', qs('[data-kali-has-spin]') || document);
    var toggleBtns = qsa('[data-kali-spin-toggle-btn]');
    if (gallerySpinView) {
      toggleBtns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (gallerySpinView.hidden) {
            if (galleryView) galleryView.hidden = true;
            gallerySpinView.hidden = false;
          } else {
            gallerySpinView.hidden = true;
            if (galleryView) galleryView.hidden = false;
          }
        });
      });
    }
  })();

  /* ---------- Quantity stepper ---------- */
  (function qty() {
    var input = qs('[data-kali-qty-input]');
    var display = qs('[data-kali-qty-value]');
    var dec = qs('[data-kali-qty-dec]');
    var inc = qs('[data-kali-qty-inc]');
    if (!input) return;

    function render() {
      if (display) display.textContent = input.value;
    }

    if (dec) dec.addEventListener('click', function () {
      input.value = Math.max(1, parseInt(input.value, 10) - 1);
      render();
    });
    if (inc) inc.addEventListener('click', function () {
      input.value = parseInt(input.value, 10) + 1;
      render();
    });
    render();
  })();

  /* ---------- Cart (AJAX) ---------- */
  var Cart = (function () {
    var drawer = qs('[data-kali-cart-drawer]');
    var backdrop = qs('[data-kali-cart-backdrop]');
    var itemsEl = qs('[data-kali-cart-items]');
    var subtotalEl = qs('[data-kali-cart-subtotal]');
    var checkoutBtn = qs('[data-kali-cart-checkout]');
    var headerBadges = qsa('[data-kali-cart-badge]');
    var cartToggleBtns = qsa('[data-kali-cart-toggle]');

    function open() {
      if (drawer) drawer.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
    }
    function close() {
      if (drawer) drawer.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
    }

    function updateBadges(count) {
      headerBadges.forEach(function (b) {
        b.textContent = count;
        b.style.display = count > 0 ? 'flex' : 'none';
        if (count > 0) {
          b.classList.remove('kali-bump');
          void b.offsetWidth; /* restart the animation even if it's already running */
          b.classList.add('kali-bump');
        }
      });
      cartToggleBtns.forEach(function (btn) {
        btn.classList.toggle('has-items', count > 0);
        btn.classList.add('kali-bump');
        setTimeout(function () { btn.classList.remove('kali-bump'); }, 500);
      });
    }

    var itemNodes = {};
    var comboEl = qs('[data-kali-combo]');
    var savingRow = qs('[data-kali-cart-saving]');
    var savingValue = qs('[data-kali-cart-saving-value]');
    var comboIds = { casco: {}, chaleco: {} };
    try {
      var comboData = JSON.parse((qs('[data-kali-combo-ids]') || {}).textContent || '{}');
      ['casco', 'chaleco'].forEach(function (k) { (comboData[k] || []).forEach(function (id) { comboIds[k][id] = true; }); });
    } catch (e) { /* sin datos de combo: no se muestra nada */ }

    function lineTotalHtml(item) {
      if (item.final_line_price < item.original_line_price) {
        return '<s class="kali-cart-item-was">' + formatMoney(item.original_line_price) + '</s>' +
          '<span class="kali-cart-item-now">' + formatMoney(item.final_line_price) + '</span>';
      }
      return formatMoney(item.final_line_price);
    }

    function comboTarget(kind) {
      return kind === 'chalecos' ? qs('.kali-vl-picker-designs') : qs('[data-kali-vl-rail-heading].is-active');
    }
    function goToCascos(kind) {
      var target = comboTarget(kind);
      if (!target) {
        window.location.href = '/pages/chalecos-para-ninos#' + (kind === 'chalecos' ? 'chalecos' : 'cascos');
        return;
      }
      close();
      setTimeout(function () {
        var top = target.getBoundingClientRect().top + window.pageYOffset - 90;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }, 250);
    }
    if (comboEl) {
      comboEl.addEventListener('click', function (e) {
        var go = e.target.closest ? e.target.closest('[data-kali-combo-go]') : null;
        if (go) goToCascos(go.getAttribute('data-kali-combo-go'));
      });
    }
    if (window.location.hash === '#cascos' || window.location.hash === '#chalecos') {
      var hashKind = window.location.hash === '#chalecos' ? 'chalecos' : 'cascos';
      window.addEventListener('load', function () {
        var t = comboTarget(hashKind);
        if (t) setTimeout(function () { window.scrollTo({ top: t.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' }); }, 400);
      });
    }

    function renderSubtotal(cart) {
      if (!subtotalEl) return;
      var saved = cart.total_discount || 0;
      if (saved > 0 && cart.original_total_price > cart.total_price) {
        subtotalEl.innerHTML = '<s class="kali-cart-sub-was">' + formatMoney(cart.original_total_price) + '</s> <span class="kali-cart-sub-now">' + formatMoney(cart.total_price) + '</span><small class="kali-cart-sub-save">Ahorraste ' + formatMoney(saved) + '</small>';
      } else {
        subtotalEl.textContent = formatMoney(cart.total_price);
      }
    }

    function renderCombo(cart) {
      if (!comboEl) return;
      var hasCasco = false, hasChaleco = false;
      cart.items.forEach(function (it) {
        if (comboIds.casco[it.product_id]) hasCasco = true;
        if (comboIds.chaleco[it.product_id]) hasChaleco = true;
      });
      var saved = cart.total_discount || 0;
      var html = '';
      if (hasCasco && hasChaleco && saved > 0) {
        html = '<span class="kali-combo-icon" aria-hidden="true">🎉</span><div class="kali-combo-text"><strong>¡Excelente elección! Protección completa para tu hijo</strong><span>Tu descuento del 10 % ya está activo · ahorraste <b>' + formatMoney(saved) + '</b></span></div>';
        comboEl.className = 'kali-combo kali-combo--on';
      } else if (hasCasco !== hasChaleco) {
        html = '<span class="kali-combo-icon" aria-hidden="true">🏷️</span><div class="kali-combo-text"><strong>' +
          'Completa tu combo y ahorra 10 %' +
          '</strong><span>' + (hasCasco
            ? 'Suma un chaleco reflectivo a tu casco y el descuento se aplica solo. Cabeza y torso protegidos.'
            : 'Suma el casco de moto para tu hijo y el descuento se aplica solo. Cabeza y torso protegidos.') + '</span></div>' +
          '<button type="button" class="kali-combo-go" data-kali-combo-go="' + (hasCasco ? 'chalecos' : 'cascos') + '">' + (hasCasco ? 'Ver chalecos' : 'Ver cascos') + '</button>';
        comboEl.className = 'kali-combo kali-combo--hint';
      }
      comboEl.innerHTML = html;
      comboEl.hidden = !html;
      if (savingRow) {
        var show = saved > 0;
        savingRow.hidden = !show;
        if (show && savingValue) savingValue.textContent = '−' + formatMoney(saved);
      }
    }

    function renderItem(item) {
      var wrap = document.createElement('div');
      wrap.className = 'kali-cart-item';
      wrap.innerHTML =
        '<img class="kali-cart-item-img" src="' + (item.image || '') + '" alt="">' +
        '<div class="kali-cart-item-body">' +
          '<span class="kali-cart-item-name">' + item.product_title + '</span>' +
          '<span class="kali-cart-item-unit">' + formatMoney(item.price) + ' c/u</span>' +
          '<div class="kali-cart-item-controls">' +
            '<div class="kali-cart-item-stepper">' +
              '<button type="button" data-kali-cart-dec>−</button>' +
              '<span class="kali-cart-item-qty">' + item.quantity + '</span>' +
              '<button type="button" data-kali-cart-inc>+</button>' +
            '</div>' +
            '<button type="button" class="kali-cart-item-remove" data-kali-cart-remove>Quitar</button>' +
          '</div>' +
        '</div>' +
        '<span class="kali-cart-item-total">' + lineTotalHtml(item) + '</span>';

      function currentQty() {
        return parseInt(wrap.querySelector('.kali-cart-item-qty').textContent, 10) || 0;
      }

      wrap.querySelector('[data-kali-cart-inc]').addEventListener('click', function () {
        changeLine(item.key, currentQty() + 1);
      });
      wrap.querySelector('[data-kali-cart-dec]').addEventListener('click', function () {
        changeLine(item.key, Math.max(0, currentQty() - 1));
      });
      wrap.querySelector('[data-kali-cart-remove]').addEventListener('click', function () {
        animateOut(wrap);
        delete itemNodes[item.key];
        changeLine(item.key, 0);
      });
      wrap.dataset.kaliQty = item.quantity;
      return wrap;
    }

    function updateItemNode(node, item) {
      var qtyEl = node.querySelector('.kali-cart-item-qty');
      var totalEl = node.querySelector('.kali-cart-item-total');
      var qtyChanged = String(item.quantity) !== node.dataset.kaliQty;
      qtyEl.textContent = item.quantity;
      totalEl.innerHTML = lineTotalHtml(item);
      node.dataset.kaliQty = item.quantity;
      if (qtyChanged) {
        qtyEl.classList.remove('kali-cart-qty-pulse');
        totalEl.classList.remove('kali-cart-qty-pulse');
        void qtyEl.offsetWidth; /* restart the animation even if it's already running */
        qtyEl.classList.add('kali-cart-qty-pulse');
        totalEl.classList.add('kali-cart-qty-pulse');
      }
    }

    function animateIn(node) {
      node.classList.add('kali-cart-item--entering');
      node.addEventListener('animationend', function handler() {
        node.classList.remove('kali-cart-item--entering');
        node.removeEventListener('animationend', handler);
      });
    }

    function animateOut(node) {
      if (node.classList.contains('kali-cart-item--leaving')) return;
      var rect = node.getBoundingClientRect();
      node.style.height = rect.height + 'px';
      node.style.overflow = 'hidden';
      node.classList.add('kali-cart-item--leaving');
      void node.offsetHeight; /* commit the fixed height before animating it away */
      requestAnimationFrame(function () {
        node.style.height = '0px';
        node.style.marginTop = '0px';
        node.style.marginBottom = '0px';
        node.style.paddingTop = '0px';
        node.style.paddingBottom = '0px';
        node.style.opacity = '0';
        node.style.transform = 'translateX(46px) scale(0.92)';
      });
      node.addEventListener('transitionend', function handler(e) {
        if (e.propertyName !== 'height') return;
        node.removeEventListener('transitionend', handler);
        if (node.parentNode) node.parentNode.removeChild(node);
      });
    }

    /* Artículos de bebé (tipo "bebes"): bajo $30.000, 2 uds 11 %, 3 uds 12 %, 4+ 13 %, +2 % si mezcla productos (máx. 13 %);
       con alguno de ellos, los de $50.000 o más llevan 5 % (sin arnés). Mismo cálculo que kali-cod.js y el servidor.
       Shopify ya descuenta la parte por cantidad; aquí se completa con la variedad y el 5 % para que el carrito lo muestre. */
    var BEBE_GRUPOS = { '8856475173140': 'rodilleras', '10125385597204': 'rodilleras', '10122308157716': 'chupetico', '10122309304596': 'chupetico' };
    var BEBE_ARNES = '10151673856276';
    function bebeAdjust(cart) {
      var isBebe = function (it) { return String(it.product_type || '').toLowerCase() === 'bebes'; };
      var isSmall = function (it) { return isBebe(it) && it.price < 3000000; };
      var isBig = function (it) { return isBebe(it) && it.price >= 5000000 && String(it.product_id) !== BEBE_ARNES; };
      var units = 0, tipos = {}, n = 0, todos = {}, nAll = 0, hasSmall = false, arnes = false;
      cart.items.forEach(function (it) {
        if (String(it.product_id) === BEBE_ARNES) arnes = true;
        if (!isBebe(it)) return;
        var t = BEBE_GRUPOS[String(it.product_id)] || String(it.product_id);
        if (!todos[t]) { todos[t] = true; nAll++; }
        if (!isSmall(it)) return;
        hasSmall = true;
        units += it.quantity;
        if (!tipos[t]) { tipos[t] = true; n++; }
      });
      if (!hasSmall) return cart;
      /* Con 1 sola unidad pequeña también aplica 11 % si hay otro producto de bebé distinto. */
      var rate = (units < 2 && !(units === 1 && nAll >= 2)) ? 0 : Math.min(13, (units >= 4 ? 13 : units === 3 ? 12 : 11) + (n >= 2 ? 2 : 0));
      var big = arnes ? 0 : 5;
      var extra = 0;
      cart.items.forEach(function (it) {
        var r = isSmall(it) ? rate : (isBig(it) ? big : 0);
        if (!r) return;
        var want = Math.round(it.price * (1 - r / 100)) * it.quantity;
        if (want < it.final_line_price) {
          extra += it.final_line_price - want;
          it.final_line_price = want;
          it.final_price = Math.round(want / it.quantity);
        }
      });
      if (extra > 0) {
        cart.total_price -= extra;
        cart.total_discount = (cart.total_discount || 0) + extra;
      }
      return cart;
    }

    var lastCart = null;

    function render(cart) {
      cart = bebeAdjust(cart);
      lastCart = cart;
      updateBadges(cart.item_count);
      if (!itemsEl) return;

      if (cart.item_count === 0) {
        itemNodes = {};
        itemsEl.innerHTML = '';
        var empty = document.createElement('div');
        empty.className = 'kali-cart-empty';
        empty.innerHTML = '<span>🛍</span><span class="kali-cart-empty-text">Tu carrito está vacío</span><button type="button" class="kali-cart-continue" data-kali-cart-continue>Seguir comprando</button>';
        empty.querySelector('[data-kali-cart-continue]').addEventListener('click', close);
        itemsEl.appendChild(empty);
        renderSubtotal(cart);
        renderCombo(cart);
        if (checkoutBtn) checkoutBtn.disabled = true;
        return;
      }

      var emptyNode = itemsEl.querySelector('.kali-cart-empty');
      if (emptyNode) emptyNode.remove();

      var newKeys = {};
      cart.items.forEach(function (item) { newKeys[item.key] = true; });
      Object.keys(itemNodes).forEach(function (key) {
        if (!newKeys[key]) {
          animateOut(itemNodes[key]);
          delete itemNodes[key];
        }
      });

      var prevNode = null;
      cart.items.forEach(function (item) {
        var node = itemNodes[item.key];
        if (!node) {
          node = renderItem(item);
          itemNodes[item.key] = node;
          var refNode = prevNode ? prevNode.nextSibling : itemsEl.firstChild;
          itemsEl.insertBefore(node, refNode);
          animateIn(node);
        } else {
          updateItemNode(node, item);
          var wantedNext = prevNode ? prevNode.nextSibling : itemsEl.firstChild;
          if (wantedNext !== node) itemsEl.insertBefore(node, wantedNext);
        }
        prevNode = node;
      });

      renderSubtotal(cart);
      renderCombo(cart);
      if (checkoutBtn) checkoutBtn.disabled = cart.item_count === 0;
    }

    function fetchCart() {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(render);
    }

    function changeLine(key, quantity) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); }).then(render);
    }

    function addItems(items) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || 'error'); });
        return fetchCart().then(function (result) {
          trackCartAdd(items);
          return result;
        });
      });
    }

    // Embudo: cuenta "agregó al carrito" por producto (el título sale del carrito ya actualizado).
    function trackCartAdd(items) {
      if (!window.kaliFunnel || !window.kaliFunnel.track || !lastCart) return;
      items.forEach(function (it) {
        var line = lastCart.items.filter(function (l) { return String(l.variant_id) === String(it.id); })[0];
        if (line) window.kaliFunnel.track('cart', line.product_title || line.title);
      });
    }

    function addItem(variantId, quantity) {
      return addItems([{ id: variantId, quantity: quantity }]);
    }

    if (backdrop) backdrop.addEventListener('click', close);
    qsa('[data-kali-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
    cartToggleBtns.forEach(function (btn) { btn.addEventListener('click', open); });

    fetchCart();

    window.kaliCart = { open: open, addItem: addItem };
    return { open: open, close: close, addItem: addItem, addItems: addItems, fetchCart: fetchCart };
  })();

  /* ---------- Pre-checkout upsell modal ----------
     Related-product cards further down the page (the native Shopify
     <product-recommendations> block) are fetched and injected via AJAX after
     this script has already run, so their modals can't all be registered
     up front. registerUpsellModal/getUpsellModal let card click handlers
     resolve (and lazily wire up) a modal that only exists in the DOM later. */
  function registerUpsellModal(modal) {
    var key = modal.getAttribute('data-kali-upsell-modal');
    if (!key) return null;
    if (kaliUpsellModals[key]) return kaliUpsellModals[key];

    var backdrop = qs('[data-kali-upsell-backdrop="' + key + '"]');
    if (!backdrop) return null;

    // Re-parent to <body>: rendered inside a card/section, an ancestor's
    // stacking context (transform, z-index, overflow) keeps the header and
    // other content above the backdrop, so it never fully covers the page.
    document.body.appendChild(backdrop);
    document.body.appendChild(modal);

    var upsellVariantId = modal.getAttribute('data-kali-upsell-variant-id');
      var discountCode = modal.getAttribute('data-kali-upsell-discount-code');
      var currentUnitPrice = parseInt(modal.getAttribute('data-kali-upsell-current-unit-price'), 10) || 0;
      var hostUnitDiscount = parseInt(modal.getAttribute('data-kali-upsell-host-unit-discount'), 10) || 0;
      var upsellPrice = parseInt(modal.getAttribute('data-kali-upsell-price'), 10) || 0;
      var savings = parseInt(modal.getAttribute('data-kali-upsell-savings'), 10) || 0;
      var acceptBtn = qs('[data-kali-upsell-accept]', modal);
      var acceptLabel = acceptBtn ? qs('[data-kali-upsell-accept-label]', acceptBtn) : null;
      var acceptLabelOriginal = acceptLabel ? acceptLabel.textContent : '';
      var declineBtn = qs('[data-kali-upsell-decline]', modal);
      var closeBtn = qs('[data-kali-upsell-close]', modal);
      var qtyEl = qs('[data-kali-upsell-current-qty]', modal);
      var linePriceEl = qs('[data-kali-upsell-current-line-price]', modal);
      var lineCompareEl = qs('[data-kali-upsell-current-line-compare]', modal);
      var savingsEl = qs('[data-kali-upsell-savings-value]', modal);
      var totalEl = qs('[data-kali-upsell-total-value]', modal);

      var state = { proceed: null, variantId: null, qty: 1 };

      function updateOrderSummary() {
        var lineTotal = currentUnitPrice * state.qty;
        var hostSavingsTotal = hostUnitDiscount * state.qty;
        var discountedLineTotal = lineTotal - hostSavingsTotal;
        if (qtyEl) qtyEl.textContent = state.qty;
        if (linePriceEl) linePriceEl.textContent = formatMoney(discountedLineTotal);
        if (lineCompareEl) lineCompareEl.textContent = formatMoney(lineTotal);
        if (savingsEl) savingsEl.textContent = formatMoney(savings + hostSavingsTotal);
        if (totalEl) totalEl.textContent = formatMoney(discountedLineTotal + upsellPrice);
      }

      function show() {
        backdrop.classList.add('is-open');
        modal.classList.add('is-open');
        document.body.classList.add('kali-upsell-open');
      }

      function hide() {
        backdrop.classList.remove('is-open');
        modal.classList.remove('is-open');
        document.body.classList.remove('kali-upsell-open');
      }

      function declineAndProceed() {
        var proceed = state.proceed;
        hide();
        // Shopify remembers codes applied via /checkout?discount= for the
        // session, so explicitly clear them: declining must not keep the offer.
        var clear;
        try {
          clear = fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ discount: '' })
          });
        } catch (err) { clear = null; }
        var go = function () { if (proceed) proceed(); };
        if (clear && clear.then) clear.then(go, go); else go();
      }

      backdrop.addEventListener('click', declineAndProceed);
      if (closeBtn) closeBtn.addEventListener('click', declineAndProceed);
      if (declineBtn) declineBtn.addEventListener('click', declineAndProceed);

      if (acceptBtn) {
        acceptBtn.addEventListener('click', function () {
          if (acceptBtn.classList.contains('is-loading') || !upsellVariantId) return;
          acceptBtn.classList.add('is-loading');
          if (acceptLabel) acceptLabel.textContent = 'Agregando…';
          Cart.addItems([
            { id: state.variantId, quantity: state.qty },
            { id: upsellVariantId, quantity: 1 }
          ]).then(function () {
            window.location.href = '/checkout?discount=' + discountCode;
          }).catch(function () {
            acceptBtn.classList.remove('is-loading');
            if (acceptLabel) acceptLabel.textContent = acceptLabelOriginal;
            showToast('No se pudo agregar la oferta, continuamos con tu compra');
            declineAndProceed();
          });
        });
      }

      var open = function (proceedFn, variantId, qty) {
        state.proceed = proceedFn;
        state.variantId = variantId;
        state.qty = qty;
        updateOrderSummary();
        show();
      };

    kaliUpsellModals[key] = { open: open };
    if (key === 'page') kaliUpsellIntercept = open;
    return kaliUpsellModals[key];
  }

  function getUpsellModal(key) {
    if (!key) return null;
    if (kaliUpsellModals[key]) return kaliUpsellModals[key];
    var modal = qs('[data-kali-upsell-modal="' + key + '"]');
    return modal ? registerUpsellModal(modal) : null;
  }

  qsa('[data-kali-upsell-modal]').forEach(registerUpsellModal);

  /* ---------- Variant / bundle picker ---------- */
  (function variantPicker() {
    var root = qs('[data-kali-variant-picker]');
    if (!root) return;
    var dataEl = qs('[data-kali-variant-data]', root);
    var variants;
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    if (!variants || !variants.length) return;

    function prettify(str) {
      var s = (str || '').replace(/\barnes\b/gi, 'Arnés');
      return s.charAt(0).toUpperCase() + s.slice(1);
    }

    function appendGiftNote(info, label) {
      if (!/rodillera/i.test(label)) return;
      if (window.location.pathname.indexOf('/products/arnes-primeros-pasos') === 0) return;
      var giftNote = document.createElement('span');
      giftNote.className = 'kali-bundle-gift';
      giftNote.textContent = '🎁 Rodilleras de regalo';
      info.appendChild(giftNote);
    }

    function renderBundlePrice(priceWrap, v) {
      priceWrap.innerHTML = '';
      var priceEl = document.createElement('span');
      priceEl.className = 'kali-bundle-price';
      priceEl.textContent = formatMoney(v.price);
      priceWrap.appendChild(priceEl);


      var hasDiscount = v.compare_at_price && v.compare_at_price > v.price;
      if (hasDiscount) {
        var compareEl = document.createElement('span');
        compareEl.className = 'kali-bundle-compare';
        compareEl.textContent = formatMoney(v.compare_at_price);
        priceWrap.appendChild(compareEl);

        var savingsEl = document.createElement('span');
        savingsEl.className = 'kali-bundle-savings';
        savingsEl.textContent = 'Ahorrás ' + formatMoney(v.compare_at_price - v.price);
        priceWrap.appendChild(savingsEl);
      }
    }

    function splitGender(text) {
      var m = /^(.*?)\s+(ni[ñn]o|ni[ñn]a)$/i.exec((text || '').trim());
      if (!m) return null;
      var genderRaw = m[2].toLowerCase();
      var gender = (genderRaw === 'nino' || genderRaw === 'niño') ? 'niño' : 'niña';
      return { base: m[1].trim(), gender: gender };
    }

    function detectGenderSplit() {
      var bases = [];
      var map = {};
      for (var i = 0; i < variants.length; i++) {
        var label = variants[i].option1 || variants[i].title;
        var parsed = splitGender(label);
        if (!parsed) return null;
        if (!map[parsed.base]) {
          map[parsed.base] = {};
          bases.push(parsed.base);
        }
        if (map[parsed.base][parsed.gender]) return null;
        map[parsed.base][parsed.gender] = variants[i];
      }
      var gendersSeen = {};
      for (var b in map) {
        var keys = Object.keys(map[b]);
        if (keys.length !== 2) return null;
        keys.forEach(function (k) { gendersSeen[k] = true; });
      }
      if (Object.keys(gendersSeen).length !== 2 || bases.length < 2) return null;
      return { bases: bases, map: map };
    }

    function applyVariant(variant) {
      if (!variant) return;
      var priceEl = qs('.kali-price');
      var priceRow = qs('.kali-price-row');
      var compareEl = qs('.kali-price-compare');
      var saveBadge = qs('.kali-save-badge');
      var installmentsEl = qs('.kali-installments');
      var stickyPriceEl = qs('[data-kali-sticky-price]');

      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(variant.price);

      var hasDiscount = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (hasDiscount && priceRow) {
        if (!compareEl) {
          compareEl = document.createElement('span');
          compareEl.className = 'kali-price-compare';
          priceRow.appendChild(compareEl);
        }
        compareEl.textContent = formatMoney(variant.compare_at_price);
        var pct = Math.round((1 - variant.price / variant.compare_at_price) * 100);
        if (!saveBadge) {
          saveBadge = document.createElement('span');
          saveBadge.className = 'kali-save-badge';
          priceRow.appendChild(saveBadge);
        }
        saveBadge.textContent = 'Save ' + pct + '%';
      } else {
        if (compareEl) compareEl.remove();
        if (saveBadge) saveBadge.remove();
      }

      if (installmentsEl) {
        installmentsEl.textContent = '3 cuotas sin interés de ' + formatMoney(Math.round(variant.price / 3));
      }

      var addToCartBtns = qsa('[data-kali-add-to-cart]');
      var buyNowBtn = qs('[data-kali-buy-now]');
      addToCartBtns.forEach(function (btn) { btn.setAttribute('data-kali-add-to-cart', variant.id); });
      var actionBtns = addToCartBtns.concat(buyNowBtn ? [buyNowBtn] : []);

      actionBtns.forEach(function (btn) {
        var addLabel = qs('[data-kali-add-label]', btn);
        var buyLabel = qs('[data-kali-buy-label]', btn);
        btn.disabled = !variant.available;
        btn.style.opacity = variant.available ? '' : '.5';
        btn.style.cursor = variant.available ? '' : 'not-allowed';
        if (addLabel) {
          addLabel.textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
        } else if (buyLabel) {
          buyLabel.textContent = variant.available ? 'Comprar ahora' : 'Agotado';
        } else if (btn.hasAttribute('data-kali-sticky-add')) {
          btn.textContent = variant.available ? 'Agregar al carrito' : 'Agotado';
        }
      });

      if (variant.featured_image && variant.featured_image.src) {
        var filename = variant.featured_image.src.split('?')[0].split('/').pop();
        var mains = qsa('[data-kali-main-photo]');
        for (var i = 0; i < mains.length; i++) {
          var mainFilename = (mains[i].getAttribute('src') || mains[i].getAttribute('data-src') || '').split('?')[0].split('/').pop();
          if (mainFilename === filename) {
            kaliGallerySelect(mains[i].getAttribute('data-kali-main-photo'));
            break;
          }
        }
      }
    }

    function scrollToGallery() {
      var gallery = qs('.kali-gallery-card');
      if (gallery) gallery.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    // Al tocar una miniatura de la galería, se elige también la opción del formulario que usa esa foto.
    var pickFromThumb = null;
    function fileOf(src) { return (src || '').split('?')[0].split('/').pop(); }
    qsa('[data-kali-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!pickFromThumb || !/kali-tpl-kali-(arnes-primeros-pasos|arnes-bebes|combo-bebes|protector-cabeza)\b/.test(document.body.className)) return;
        var main = qs('[data-kali-main-photo="' + thumb.getAttribute('data-kali-thumb') + '"]');
        if (!main) return;
        var file = fileOf(main.getAttribute('src') || main.getAttribute('data-src'));
        var pair = main.getAttribute('data-kali-device') ? main.getAttribute('data-kali-pair') : '';
        var found = null;
        variants.forEach(function (v) {
          if (found || !v.featured_image || !v.featured_image.src) return;
          var vf = fileOf(v.featured_image.src);
          if (vf === file) { found = v; return; }
          if (pair) {
            qsa('[data-kali-main-photo]').forEach(function (m) {
              if (m.getAttribute('data-kali-device') && m.getAttribute('data-kali-pair') === pair && fileOf(m.getAttribute('src') || m.getAttribute('data-src')) === vf) found = v;
            });
          }
        });
        if (found) { pickFromThumb(found); return; }
        // Foto sin opción propia: si el nombre del archivo dice nina / nino, al menos se cambia el género.
        var g = /nina/i.test(file) ? 'niña' : (/nino/i.test(file) ? 'niño' : null);
        if (g) pickFromThumb({ gender: g });
      });
    });

    function buildGenderSplitUI(container, detected) {
      var firstGender = splitGender(variants[0].option1 || variants[0].title).gender;
      var genders = firstGender === 'niña' ? ['niña', 'niño'] : ['niño', 'niña'];
      var state = { gender: genders[0], base: detected.bases[0] };

      var wrap = document.createElement('div');
      wrap.className = 'kali-picker-steps';

      var step1 = document.createElement('div');
      step1.className = 'kali-picker-group';
      var label1 = document.createElement('span');
      label1.className = 'kali-picker-label';
      label1.textContent = '1 · Elegí el género';
      step1.appendChild(label1);

      var genderRow = document.createElement('div');
      genderRow.className = 'kali-gender-pills';
      genders.forEach(function (g) {
        var genderModifier = g === 'niña' ? 'kali-gender-pill--nina' : 'kali-gender-pill--nino';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'kali-gender-pill ' + genderModifier + (g === state.gender ? ' is-selected' : '');
        btn.innerHTML = (g === 'niña' ? '<span class="kali-gender-pill-icon">👧</span>Niña' : '<span class="kali-gender-pill-icon">👦</span>Niño');
        btn.addEventListener('click', function () {
          if (state.gender === g) return;
          state.gender = g;
          qsa('.kali-gender-pill', genderRow).forEach(function (b) { b.classList.toggle('is-selected', b === btn); });
          update();
          scrollToGallery();
        });
        genderRow.appendChild(btn);
      });
      step1.appendChild(genderRow);

      var step2 = document.createElement('div');
      step2.className = 'kali-picker-group';
      var label2 = document.createElement('span');
      label2.className = 'kali-picker-label';
      label2.textContent = '2 · Elegí tu combo';
      step2.appendChild(label2);

      var cardList = document.createElement('div');
      cardList.className = 'kali-bundle-list';
      var recommendedIndex = detected.bases.length === 3 ? 1 : -1;

      detected.bases.forEach(function (base, idx) {
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'kali-bundle-card' + (base === state.base ? ' is-selected' : '');

        var radio = document.createElement('span');
        radio.className = 'kali-bundle-radio';

        var info = document.createElement('span');
        info.className = 'kali-bundle-info';
        var title = document.createElement('span');
        title.className = 'kali-bundle-title';
        title.textContent = prettify(base);
        info.appendChild(title);
        if (idx === recommendedIndex) {
          var badge = document.createElement('span');
          badge.className = 'kali-bundle-badge';
          badge.textContent = 'Más elegido';
          info.appendChild(badge);
        }
        appendGiftNote(info, base);

        var priceWrap = document.createElement('span');
        priceWrap.className = 'kali-bundle-price-wrap';

        card.appendChild(radio);
        card.appendChild(info);
        card.appendChild(priceWrap);

        card.addEventListener('click', function () {
          if (state.base === base) return;
          state.base = base;
          qsa('.kali-bundle-card', cardList).forEach(function (c) { c.classList.toggle('is-selected', c === card); });
          update();
          scrollToGallery();
        });

        cardList.appendChild(card);
      });
      step2.appendChild(cardList);

      wrap.appendChild(step1);
      wrap.appendChild(step2);
      container.appendChild(wrap);

      function update() {
        qsa('.kali-bundle-card', cardList).forEach(function (c, idx) {
          var v = detected.map[detected.bases[idx]][state.gender];
          renderBundlePrice(qs('.kali-bundle-price-wrap', c), v);
          c.classList.toggle('is-unavailable', !v.available);
        });
        applyVariant(detected.map[state.base][state.gender]);
      }

      pickFromThumb = function (v) {
        var p = v.gender ? { gender: v.gender, base: state.base } : splitGender(v.option1 || v.title);
        if (!p) return;
        state.gender = p.gender;
        state.base = p.base;
        qsa('.kali-gender-pill', genderRow).forEach(function (b, i) { b.classList.toggle('is-selected', genders[i] === state.gender); });
        qsa('.kali-bundle-card', cardList).forEach(function (c, i) { c.classList.toggle('is-selected', detected.bases[i] === state.base); });
        update();
      };

      update();
    }

    function buildFlatUI(container) {
      var wrap = document.createElement('div');
      wrap.className = 'kali-picker-steps';
      var step = document.createElement('div');
      step.className = 'kali-picker-group';
      var label = document.createElement('span');
      label.className = 'kali-picker-label';
      label.textContent = 'Elegí una opción';
      step.appendChild(label);

      var list = document.createElement('div');
      list.className = 'kali-bundle-list';

      variants.forEach(function (v, idx) {
        var card = document.createElement('button');
        card.type = 'button';
        card.className = 'kali-bundle-card' + (idx === 0 ? ' is-selected' : '') + (v.available ? '' : ' is-unavailable');

        var radio = document.createElement('span');
        radio.className = 'kali-bundle-radio';

        var info = document.createElement('span');
        info.className = 'kali-bundle-info';
        var title = document.createElement('span');
        title.className = 'kali-bundle-title';
        title.textContent = prettify(v.option1 || v.title);
        info.appendChild(title);
        if (!v.available) {
          var badge = document.createElement('span');
          badge.className = 'kali-bundle-badge is-out';
          badge.textContent = 'Agotado';
          info.appendChild(badge);
        }
        appendGiftNote(info, v.option1 || v.title);

        var priceWrap = document.createElement('span');
        priceWrap.className = 'kali-bundle-price-wrap';
        renderBundlePrice(priceWrap, v);

        card.appendChild(radio);
        card.appendChild(info);
        card.appendChild(priceWrap);

        card.addEventListener('click', function () {
          qsa('.kali-bundle-card', list).forEach(function (c) { c.classList.remove('is-selected'); });
          card.classList.add('is-selected');
          applyVariant(v);
          scrollToGallery();
        });

        list.appendChild(card);
      });

      step.appendChild(list);
      wrap.appendChild(step);
      container.appendChild(wrap);
      applyVariant(variants[0]);
    }

    var detected = detectGenderSplit();
    if (detected) {
      buildGenderSplitUI(root, detected);
    } else {
      buildFlatUI(root);
    }
  })();

  /* ---------- Add to cart / Buy now ---------- */
  (function addToCart() {
    var addBtn = qs('[data-kali-add-to-cart]');
    var buyBtn = qs('[data-kali-buy-now]');
    var stickyBtn = qs('[data-kali-sticky-add]');
    var qtyInput = qs('[data-kali-qty-input]');

    function currentQty() {
      return qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
    }

    function currentVariantId() {
      // Re-read at click time: a variant picker may have changed this since page load.
      return addBtn ? addBtn.getAttribute('data-kali-add-to-cart') : null;
    }

    // Complementos (p. ej. rodilleras) que otra plantilla puede sumar a la compra: window.kaliExtraItems() -> [{id, quantity}]
    function addMain() {
      var extra = typeof window.kaliExtraItems === 'function' ? window.kaliExtraItems() : [];
      if (!extra.length) return Cart.addItem(currentVariantId(), currentQty());
      return Cart.addItems([{ id: currentVariantId(), quantity: currentQty() }].concat(extra));
    }

    function pulse(btn, addedLabelEl) {
      btn.classList.add('is-added');
      if (addedLabelEl) {
        var original = addedLabelEl.textContent;
        addedLabelEl.textContent = '¡Agregado!';
        setTimeout(function () {
          btn.classList.remove('is-added');
          addedLabelEl.textContent = original;
        }, 1400);
      }
    }

    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var label = qs('[data-kali-add-label]', addBtn);

        function proceed() {
          addMain().then(function () {
            pulse(addBtn, label);
            Cart.open();
          }).catch(function () {
            showToast('No se pudo agregar al carrito');
          });
        }

        if (kaliUpsellIntercept) {
          kaliUpsellIntercept(proceed, currentVariantId(), currentQty());
        } else {
          proceed();
        }
      });
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        function proceed() {
          addMain().then(function () {
            Cart.open();
          }).catch(function () {
            showToast('No se pudo agregar al carrito');
          });
        }

        if (kaliUpsellIntercept) {
          kaliUpsellIntercept(proceed, currentVariantId(), currentQty());
        } else {
          proceed();
        }
      });
    }

    if (buyBtn) {
      buyBtn.addEventListener('click', function () {
        var label = qs('[data-kali-buy-label]', buyBtn);
        var original = label ? label.textContent : '';

        function proceed() {
          buyBtn.classList.add('is-loading');
          if (label) label.textContent = 'Procesando compra…';
          addMain().then(function () {
            buyBtn.classList.remove('is-loading');
            if (label) label.textContent = original;
            Cart.open();
          }).catch(function () {
            buyBtn.classList.remove('is-loading');
            if (label) label.textContent = original;
            showToast('No se pudo procesar la compra');
          });
        }

        if (kaliUpsellIntercept) {
          kaliUpsellIntercept(proceed, currentVariantId(), currentQty());
        } else {
          proceed();
        }
      });
    }
  })();

  /* ---------- Baby-style related cards: click to pick, photos cycle on the picked card ----------
     First click on a card marks it as chosen and cycles through its product photos;
     clicking the image of an already-chosen card goes to the product page. */
  (function () {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var cycleTimer = null;
    var cycleCard = null;

    function resetCard(card) {
      var img = card.querySelector('.kali-related-img-wrap img');
      var def = card.getAttribute('data-img');
      if (img && def) { img.classList.remove('is-cycling'); img.src = def; img.removeAttribute('srcset'); }
    }

    function stopCycle() {
      if (cycleTimer) { clearInterval(cycleTimer); cycleTimer = null; }
      if (cycleCard) { resetCard(cycleCard); cycleCard = null; }
    }

    function startCycle(card) {
      stopCycle();
      cycleCard = card;
      if (reduceMotion) return;
      var img = card.querySelector('.kali-related-img-wrap img');
      var urls = (card.getAttribute('data-images') || '').split(',').filter(Boolean);
      if (!img || urls.length < 2) return;
      var idx = 0;
      cycleTimer = setInterval(function () {
        idx = (idx + 1) % urls.length;
        img.classList.add('is-cycling');
        setTimeout(function () {
          img.removeAttribute('srcset');
          img.src = urls[idx];
          img.classList.remove('is-cycling');
        }, 220);
      }, 2200);
    }

    document.addEventListener('click', function (e) {
      var card = e.target.closest ? e.target.closest('[data-kali-baby-card]') : null;
      if (!card) return;
      if (e.target.closest('button')) return;
      if (e.target.closest('a')) return;
      var main = card.querySelector('a.kali-related-img-wrap');
      if (main && main.href) window.location.href = main.href;
    });

    function selectCard(card) {
      Array.prototype.forEach.call(document.querySelectorAll('[data-kali-baby-card].is-selected'), function (c) {
        c.classList.remove('is-selected');
      });
      card.classList.add('is-selected');
      startCycle(card);
    }

    /* The first card starts out chosen */
    function preselectFirst() {
      var first = document.querySelector('[data-kali-baby-card]');
      if (first) selectCard(first);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', preselectFirst);
    } else {
      preselectFirst();
    }
  })();

  /* ---------- Add to cart from product cards (related products / collection grid) ----------
     Delegated on document (not bound per-button at load time) because cards
     inside the native <product-recommendations> block are injected via AJAX
     well after this script runs. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-kali-card-add-to-cart]') : null;
    if (!btn) return;
    var variantId = btn.getAttribute('data-kali-card-add-to-cart');
    if (!variantId || btn.classList.contains('is-loading')) return;
    var label = qs('[data-kali-card-add-label]', btn);
    var original = label ? label.textContent : '';

    function proceed() {
      btn.classList.add('is-loading');
      Cart.addItem(variantId, 1).then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        if (label) label.textContent = '¡Agregado!';
        Cart.open();
        setTimeout(function () {
          btn.classList.remove('is-added');
          if (label) label.textContent = original;
        }, 1400);
      }).catch(function () {
        btn.classList.remove('is-loading');
        showToast('No se pudo agregar al carrito');
      });
    }

    var upsell = getUpsellModal(btn.getAttribute('data-kali-card-upsell-key'));
    if (upsell) {
      upsell.open(proceed, variantId, 1);
    } else {
      proceed();
    }
  });

  /* ---------- Buy now from product cards (related products / collection grid) ----------
     Also delegated on document — see comment above. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-kali-card-buy-now]') : null;
    if (!btn) return;
    var variantId = btn.getAttribute('data-kali-card-buy-now');
    if (!variantId || btn.classList.contains('is-loading')) return;
    var label = qs('[data-kali-card-buynow-label]', btn);
    var original = label ? label.textContent : '';

    function proceed() {
      btn.classList.add('is-loading');
      if (label) label.textContent = 'Procesando compra…';
      Cart.addItem(variantId, 1).then(function () {
        if (btn.hasAttribute('data-kali-card-no-checkout')) {
          btn.classList.remove('is-loading');
          if (label) label.textContent = original;
          Cart.open();
          return;
        }
        window.location.href = window.routes.cart_url.replace(/\/cart$/, '/checkout');
      }).catch(function () {
        btn.classList.remove('is-loading');
        if (label) label.textContent = original;
        showToast('No se pudo procesar la compra');
      });
    }

    var upsell = getUpsellModal(btn.getAttribute('data-kali-card-upsell-key'));
    if (upsell) {
      upsell.open(proceed, variantId, 1);
    } else {
      proceed();
    }
  });

  /* ---------- Product details: hotspots + materials accordion ---------- */
  (function productDetails() {
    var photo = qs('.kali-hotspot-photo-wrap img');
    if (photo) {
      photo.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
      });
    }

    var markers = qsa('[data-kali-hotspot]');
    var details = qsa('[data-kali-hotspot-detail]');

    var hotspotModal = qs('[data-kali-hotspot-modal]');
    var hotspotModalBackdrop = qs('[data-kali-hotspot-modal-backdrop]');
    var hotspotModalClose = qs('[data-kali-hotspot-modal-close]');
    var hotspotModalNum = qs('[data-kali-hotspot-modal-num]');
    var hotspotModalTitle = qs('[data-kali-hotspot-modal-title]');
    var hotspotModalText = qs('[data-kali-hotspot-modal-text]');

    function openHotspotModal(index) {
      if (!hotspotModal) return;
      var detail = qs('[data-kali-hotspot-detail="' + index + '"]');
      if (!detail) return;
      var h3 = qs('h3', detail);
      var p = qs('p', detail);
      if (hotspotModalNum) hotspotModalNum.textContent = String(Number(index) + 1);
      if (hotspotModalTitle) hotspotModalTitle.textContent = h3 ? h3.textContent : '';
      if (hotspotModalText) hotspotModalText.textContent = p ? p.textContent : '';
      hotspotModal.classList.add('is-open');
      if (hotspotModalBackdrop) hotspotModalBackdrop.classList.add('is-open');
    }
    function closeHotspotModal() {
      if (hotspotModal) hotspotModal.classList.remove('is-open');
      if (hotspotModalBackdrop) hotspotModalBackdrop.classList.remove('is-open');
    }
    if (hotspotModalClose) hotspotModalClose.addEventListener('click', closeHotspotModal);
    if (hotspotModalBackdrop) hotspotModalBackdrop.addEventListener('click', closeHotspotModal);
    if (hotspotModal) hotspotModal.addEventListener('click', closeHotspotModal);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeHotspotModal();
    });

    markers.forEach(function (marker) {
      marker.addEventListener('click', function () {
        var index = marker.getAttribute('data-kali-hotspot');
        markers.forEach(function (m) { m.classList.toggle('is-active', m.getAttribute('data-kali-hotspot') === index); });
        details.forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-kali-hotspot-detail') === index); });
        openHotspotModal(index);
      });
    });

    qsa('[data-kali-material]').forEach(function (item) {
      var toggle = qs('[data-kali-material-toggle]', item);
      if (!toggle) return;
      toggle.addEventListener('click', function () {
        item.classList.toggle('is-open');
      });
    });
  })();

  /* ---------- Generic tab groups (usage guide, shipping/returns, etc.) ---------- */
  (function tabGroups() {
    var tabs = qsa('[data-kali-tab]');
    var panels = qsa('[data-kali-tab-panel]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var index = tab.getAttribute('data-kali-tab');
        tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-kali-tab') === index); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-kali-tab-panel') === index); });
      });
    });
  })();

  /* ---------- Sticky mobile bar ---------- */
  (function stickyBar() {
    var bar = qs('[data-kali-sticky-bar]');
    if (!bar) return;
    var heroEl = qs('[data-kali-hero]');
    window.addEventListener('scroll', function () {
      var show = window.innerWidth < 720 && window.scrollY > 480;
      bar.classList.toggle('is-visible', show);
    }, { passive: true });
  })();

  /* ---------- Payment info popup ---------- */
  (function paymentPopup() {
    var popup = qs('[data-kali-payment-popup]');
    var backdrop = qs('[data-kali-payment-popup-backdrop]');
    var closeBtn = qs('[data-kali-payment-popup-close]');
    var triggers = qsa('[data-kali-payment-info-btn]');
    if (!popup || !triggers.length) return;

    function open() {
      popup.classList.add('is-open');
      if (backdrop) backdrop.classList.add('is-open');
    }
    function close() {
      popup.classList.remove('is-open');
      if (backdrop) backdrop.classList.remove('is-open');
    }

    triggers.forEach(function (btn) { btn.addEventListener('click', open); });
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);
    popup.addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  })();

  /* ---------- Home: interactive category selector ---------- */
  (function categorySelector() {
    var root = qs('[data-kali-cat-selector]');
    if (!root) return;
    var panels = qsa('[data-kali-cat-panel]', root);
    if (!panels.length) return;

    panels.forEach(function (panel, i) {
      setTimeout(function () { panel.classList.add('is-in'); }, 90 * i);
    });

    var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    function activate(panel) {
      panels.forEach(function (p) { p.classList.toggle('is-active', p === panel); });
    }

    panels.forEach(function (panel) {
      if (canHover) {
        panel.addEventListener('mouseenter', function () { activate(panel); });
      } else {
        panel.addEventListener('click', function (e) {
          if (!panel.classList.contains('is-active')) {
            e.preventDefault();
            activate(panel);
          }
        });
      }
    });
  })();

  /* ---------- Footer newsletter ---------- */
  (function newsletter() {
    var form = qs('#KaliNewsletterFooter');
    if (!form) return;
    var input = qs('[data-kali-newsletter-email]', form);
    var btn = qs('[data-kali-newsletter-submit]', form);
    var errorEl = qs('[data-kali-newsletter-error]', form);
    var label = qs('[data-kali-newsletter-label]', btn);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = input ? input.value.trim() : '';
      if (!email || email.indexOf('@') === -1) {
        if (errorEl) errorEl.textContent = 'Ingresá un email válido para suscribirte.';
        return;
      }
      if (errorEl) errorEl.textContent = '';
      fetch(form.action, { method: 'POST', body: new FormData(form) })
        .then(function () {
          btn.classList.add('is-subscribed');
          if (label) label.textContent = '¡Suscrito! ✓';
          showToast('¡Gracias por suscribirte!');
          setTimeout(function () {
            btn.classList.remove('is-subscribed');
            if (label) label.textContent = 'Suscribirme';
            if (input) input.value = '';
          }, 2200);
        })
        .catch(function () {
          if (errorEl) errorEl.textContent = 'No se pudo suscribir, intentá de nuevo.';
        });
    });
  })();

  /* ---------- Full cart page (/cart) quantity stepper ---------- */
  (function cartPageStepper() {
    qsa('[data-kali-cart-page-stepper]').forEach(function (stepper) {
      var input = qs('[data-kali-cart-page-qty]', stepper);
      var dec = qs('[data-kali-cart-page-dec]', stepper);
      var inc = qs('[data-kali-cart-page-inc]', stepper);
      var form = stepper.closest('form');
      if (!input || !form) return;

      function submit() {
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.submit();
      }

      dec.addEventListener('click', function () {
        input.value = Math.max(0, (parseInt(input.value, 10) || 0) - 1);
        submit();
      });
      inc.addEventListener('click', function () {
        input.value = (parseInt(input.value, 10) || 0) + 1;
        submit();
      });
      input.addEventListener('change', function () {
        if (input.value === '' || parseInt(input.value, 10) < 0) input.value = 0;
        submit();
      });
    });
  })();

  /* ---------- Animated stat counters (e.g. "Quienes somos") ---------- */
  (function counters() {
    var counterEls = qsa('[data-count-to]');
    if (!counterEls.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function formatNumber(n) {
      return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }

    function animate(el) {
      var target = parseInt(el.getAttribute('data-count-to'), 10) || 0;
      var suffix = el.getAttribute('data-count-suffix') || '';
      if (reduceMotion) {
        el.textContent = formatNumber(target) + suffix;
        return;
      }
      var duration = 1600;
      var start = null;
      function step(timestamp) {
        if (!start) start = timestamp;
        var progress = Math.min((timestamp - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progress, 3);
        el.textContent = formatNumber(target * eased) + suffix;
        if (progress < 1) window.requestAnimationFrame(step);
      }
      window.requestAnimationFrame(step);
    }

    if ('IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animate(entry.target);
            obs.unobserve(entry.target);
          }
        });
      }, { threshold: 0.4 });
      counterEls.forEach(function (el) { obs.observe(el); });
    } else {
      counterEls.forEach(animate);
    }
  })();

  /* ---------- Vest landing page (chalecos-para-ninos) ---------- */
  (function vestLanding() {
    var root = qs('[data-kali-vest-landing]');
    if (!root) return;

    var genderRoot = qs('[data-kali-vl-gender-root]', root);
    if (genderRoot) {
      if ('IntersectionObserver' in window) {
        var genderObs = new IntersectionObserver(function (entries) {
          if (entries[0].isIntersecting) {
            genderRoot.classList.add('is-visible');
            genderObs.disconnect();
          }
        }, { threshold: 0.3 });
        genderObs.observe(genderRoot);
        setTimeout(function () { genderRoot.classList.add('is-visible'); }, 3000);
      } else {
        genderRoot.classList.add('is-visible');
      }
    }

    var wordEl = qs('[data-kali-vl-word]', root);
    var wordCheckEl = qs('[data-kali-vl-word-check]', root);
    var wordList = [];
    if (wordEl) {
      var raw = wordEl.getAttribute('data-kali-vl-word-list');
      wordList = raw ? raw.split('|') : [];
    }
    var wordIndex = 0;
    if (wordList.length > 1 && wordEl) {
      setInterval(function () {
        wordIndex = (wordIndex + 1) % wordList.length;
        wordEl.textContent = wordList[wordIndex];
        wordEl.classList.toggle('is-b');
        if (wordCheckEl) wordCheckEl.classList.toggle('is-b');
      }, 2800);
    }

    var ctaEls = qsa('[data-kali-vl-cta]', root);
    var stickyCta = qs('[data-kali-vl-sticky-cta]', root);
    var stickyAddBtn = qs('[data-kali-vl-sticky-add]', root);
    var addToCartBtn = qs('[data-kali-vl-add-to-cart]', root);
    var addToCartLabel = addToCartBtn ? qs('[data-kali-vl-add-label]', addToCartBtn) : null;
    var addToCartLabelOriginal = addToCartLabel ? addToCartLabel.textContent : '';
    var previewImg = qs('[data-kali-vl-preview-img]', root);
    var priceEl = qs('[data-kali-vl-price]', root);
    var nameEl = qs('[data-kali-vl-name]', root);
    var genderEl = qs('[data-kali-vl-gender-label]', root);
    var stickyImg = qs('[data-kali-vl-sticky-img]', root);
    var stickyPrice = qs('[data-kali-vl-sticky-price]', root);
    var stickyName = qs('[data-kali-vl-sticky-name]', root);
    var galleryEls = qsa('[data-kali-vl-gallery]', root);
    var galleryLabelEls = qsa('[data-kali-vl-gallery-label]', root);
    var lightbox = qs('[data-kali-vl-lightbox]', root);
    var lightboxImg = lightbox ? qs('[data-kali-vl-lightbox-img]', lightbox) : null;
    var lightboxCloseBtn = lightbox ? qs('[data-kali-vl-lightbox-close]', lightbox) : null;
    var lightboxPrevBtn = lightbox ? qs('[data-kali-vl-lightbox-prev]', lightbox) : null;
    var lightboxNextBtn = lightbox ? qs('[data-kali-vl-lightbox-next]', lightbox) : null;
    var lightboxCountEl = lightbox ? qs('[data-kali-vl-lightbox-count]', lightbox) : null;
    var lightboxImages = [];
    var lightboxIndex = 0;
    var lightboxAlt = '';

    function showLightboxImage() {
      if (!lightboxImg || !lightboxImages.length) return;
      lightboxImg.src = lightboxImages[lightboxIndex];
      lightboxImg.alt = lightboxAlt;
      if (lightboxCountEl) lightboxCountEl.textContent = (lightboxIndex + 1) + ' / ' + lightboxImages.length;
      var multiple = lightboxImages.length > 1;
      if (lightboxPrevBtn) lightboxPrevBtn.hidden = !multiple;
      if (lightboxNextBtn) lightboxNextBtn.hidden = !multiple;
      if (lightboxCountEl) lightboxCountEl.hidden = !multiple;
    }

    function openLightbox(urls, index, alt) {
      if (!lightbox || !lightboxImg || !urls.length) return;
      lightboxImages = urls;
      lightboxIndex = index;
      lightboxAlt = alt || '';
      showLightboxImage();
      lightbox.classList.add('is-open');
    }

    function closeLightbox() {
      if (!lightbox) return;
      lightbox.classList.remove('is-open');
    }

    function lightboxStep(dir) {
      if (!lightboxImages.length) return;
      lightboxIndex = (lightboxIndex + dir + lightboxImages.length) % lightboxImages.length;
      showLightboxImage();
    }

    if (lightbox) {
      lightbox.addEventListener('click', function (e) {
        if (e.target === lightbox) closeLightbox();
      });
      if (lightboxCloseBtn) lightboxCloseBtn.addEventListener('click', closeLightbox);
      if (lightboxPrevBtn) lightboxPrevBtn.addEventListener('click', function () { lightboxStep(-1); });
      if (lightboxNextBtn) lightboxNextBtn.addEventListener('click', function () { lightboxStep(1); });
      document.addEventListener('keydown', function (e) {
        if (!lightbox.classList.contains('is-open')) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') lightboxStep(-1);
        if (e.key === 'ArrowRight') lightboxStep(1);
      });
    }

    function renderGallery(rail, imagesRaw, name) {
      var category = rail ? (rail.getAttribute('data-kali-vl-rail-category') || 'chaleco') : 'chaleco';
      var galleryEl = null;
      var galleryLabelEl = null;
      galleryEls.forEach(function (el) { if (el.getAttribute('data-kali-vl-gallery') === category) galleryEl = el; });
      galleryLabelEls.forEach(function (el) { if (el.getAttribute('data-kali-vl-gallery-label') === category) galleryLabelEl = el; });
      if (!galleryEl) return;
      galleryEl.innerHTML = '';
      var urls = imagesRaw ? imagesRaw.split(',').filter(Boolean) : [];
      if (galleryLabelEl) galleryLabelEl.hidden = urls.length === 0;
      urls.forEach(function (url, i) {
        var img = document.createElement('img');
        img.src = url;
        img.loading = 'lazy';
        img.alt = name || '';
        img.addEventListener('click', function () { openLightbox(urls, i, name); });
        galleryEl.appendChild(img);
      });
    }

    var thumbCycleTimer = null;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function stopThumbCycle() {
      if (thumbCycleTimer) {
        clearInterval(thumbCycleTimer);
        thumbCycleTimer = null;
      }
    }

    function startThumbCycle(thumb) {
      stopThumbCycle();
      if (reduceMotion) return;
      var media = qs('.kali-vl-thumb-media img', thumb);
      var urls = (thumb.getAttribute('data-images') || '').split(',').filter(Boolean);
      if (!media || urls.length < 2) return;
      var idx = 0;
      thumbCycleTimer = setInterval(function () {
        idx = (idx + 1) % urls.length;
        media.classList.add('is-cycling');
        setTimeout(function () {
          /* data-images holds 1200px URLs (gallery/lightbox); the thumb only shows ~200px */
          media.removeAttribute('srcset');
          media.src = urls[idx].replace('width=1200', 'width=360');
          media.classList.remove('is-cycling');
        }, 220);
      }, 2200);
    }

    function selectThumb(thumb, animate) {
      var rail = thumb.closest('[data-kali-vl-rail]');
      var prevSelected = qs('.kali-vl-thumb.is-selected', rail);
      if (prevSelected && prevSelected !== thumb) {
        var prevMedia = qs('.kali-vl-thumb-media img', prevSelected);
        var prevDefault = prevSelected.getAttribute('data-img');
        if (prevMedia && prevDefault) prevMedia.src = prevDefault;
      }
      stopThumbCycle();
      qsa('.kali-vl-thumb.is-selected', rail).forEach(function (t) {
        t.classList.remove('is-selected');
      });
      thumb.classList.add('is-selected');
      startThumbCycle(thumb);

      var url = thumb.getAttribute('data-url');
      var name = thumb.getAttribute('data-name');
      var price = thumb.getAttribute('data-price');
      var img = thumb.getAttribute('data-img');
      var corto = thumb.getAttribute('data-corto');
      var genderLabel = thumb.getAttribute('data-gender-label');
      var variantId = thumb.getAttribute('data-variant-id');
      var available = thumb.getAttribute('data-available') !== 'false';

      renderGallery(rail, thumb.getAttribute('data-images'), name);

      ctaEls.forEach(function (a) {
        a.href = url;
        a.setAttribute('data-variant-id', variantId);
      });
      if (stickyCta) {
        stickyCta.href = url;
        stickyCta.setAttribute('data-variant-id', variantId);
      }
      if (addToCartBtn) {
        addToCartBtn.setAttribute('data-variant-id', variantId);
        addToCartBtn.disabled = !available;
      }
      if (addToCartLabel) addToCartLabel.textContent = available ? addToCartLabelOriginal : 'Agotado';
      if (stickyAddBtn) {
        stickyAddBtn.setAttribute('data-variant-id', variantId);
        stickyAddBtn.disabled = !available;
      }
      if (priceEl) priceEl.textContent = price;
      if (nameEl) {
        nameEl.textContent = name;
        if (animate) { nameEl.classList.toggle('is-b'); }
      }
      if (genderEl) genderEl.textContent = genderLabel;
      if (previewImg) {
        previewImg.src = img;
        previewImg.alt = name;
        if (animate) { previewImg.classList.toggle('is-b'); }
      }
      if (stickyImg) stickyImg.src = img;
      if (stickyPrice) stickyPrice.textContent = price;
      if (stickyName) stickyName.textContent = corto;
    }

    qsa('[data-kali-vl-pick]', root).forEach(function (thumb) {
      /* Clic en la tarjeta (foto, nombre, etc.) lleva a la página del producto */
      function goToProduct() {
        var detailUrl = thumb.getAttribute('data-url');
        if (detailUrl) window.location.href = detailUrl;
      }
      thumb.addEventListener('click', goToProduct);

      var buyBtn = qs('[data-kali-vl-thumb-buy]', thumb);
      if (buyBtn) {
        buyBtn.addEventListener('click', function (e) {
          e.stopPropagation();
          goToCheckout(buyBtn);
        });
        buyBtn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            e.stopPropagation();
            goToCheckout(buyBtn);
          }
        });
      }

      var addBtn = qs('[data-kali-vl-thumb-add]', thumb);
      if (addBtn) {
        var addToCart = function (e) {
          e.stopPropagation();
          if (addBtn.classList.contains('is-loading')) return;
          var variantId = addBtn.getAttribute('data-variant-id');
          if (!variantId) return;
          var original = addBtn.textContent;
          addBtn.classList.add('is-loading');
          addBtn.textContent = 'Agregando…';
          Cart.addItem(variantId, 1).then(function () {
            addBtn.classList.remove('is-loading');
            addBtn.textContent = original;
            Cart.open();
          }).catch(function () {
            addBtn.classList.remove('is-loading');
            addBtn.textContent = original;
            showToast('No se pudo agregar al carrito');
          });
        };
        addBtn.addEventListener('click', addToCart);
        addBtn.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            addToCart(e);
          }
        });
      }
    });

    var initialSelected = qs('.kali-vl-rail.is-active .kali-vl-thumb.is-selected', root);
    if (initialSelected) startThumbCycle(initialSelected);

    /* CTA buttons: add selected vest to cart and go straight to checkout */
    function goToCheckout(el) {
      if (el.classList.contains('is-loading')) return;
      var variantId = el.getAttribute('data-variant-id');
      if (!variantId) return;
      el.classList.add('is-loading');
      Cart.addItem(variantId, 1).then(function () {
        el.classList.remove('is-loading');
        Cart.open();
      }).catch(function () {
        el.classList.remove('is-loading');
        showToast('No se pudo procesar la compra');
      });
    }

    ctaEls.concat(stickyCta ? [stickyCta] : []).forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        goToCheckout(el);
      });
    });

    /* Secondary CTA: add to cart without leaving the page */
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function () {
        if (addToCartBtn.classList.contains('is-loading') || addToCartBtn.disabled) return;
        var variantId = addToCartBtn.getAttribute('data-variant-id');
        if (!variantId) return;
        addToCartBtn.classList.add('is-loading');
        if (addToCartLabel) addToCartLabel.textContent = 'Agregando…';
        Cart.addItem(variantId, 1).then(function () {
          addToCartBtn.classList.remove('is-loading');
          if (addToCartLabel) addToCartLabel.textContent = addToCartLabelOriginal;
          Cart.open();
        }).catch(function () {
          addToCartBtn.classList.remove('is-loading');
          if (addToCartLabel) addToCartLabel.textContent = addToCartLabelOriginal;
          showToast('No se pudo agregar al carrito');
        });
      });
    }

    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function () {
        if (stickyAddBtn.classList.contains('is-loading') || stickyAddBtn.disabled) return;
        var variantId = stickyAddBtn.getAttribute('data-variant-id');
        if (!variantId) return;
        stickyAddBtn.classList.add('is-loading');
        Cart.addItem(variantId, 1).then(function () {
          stickyAddBtn.classList.remove('is-loading');
          Cart.open();
        }).catch(function () {
          stickyAddBtn.classList.remove('is-loading');
          showToast('No se pudo agregar al carrito');
        });
      });
    }

    /* Tabs: category (chaleco/casco) + gender (niño/niña) */
    var categoryTabs = qsa('[data-kali-vl-category-tab]', root);
    var categoryPanels = qsa('[data-kali-vl-category-panel]', root);
    var tabs = qsa('[data-kali-vl-tab]', root);
    var rails = qsa('[data-kali-vl-rail]', root);
    var countEl = qs('[data-kali-vl-count]', root);
    var currentCategory = 'chaleco';

    function updateActiveRail(animate) {
      var currentGender = qs('[data-kali-vl-tab].is-active', root);
      currentGender = currentGender ? currentGender.getAttribute('data-kali-vl-tab') : 'nino';
      rails.forEach(function (rail) {
        var railCategory = rail.getAttribute('data-kali-vl-rail-category') || 'chaleco';
        /* chalecos y cascos se muestran juntos (cascos debajo) para el género elegido */
        var isTarget = rail.getAttribute('data-kali-vl-rail') === currentGender;
        rail.classList.toggle('is-active', isTarget);
        if (isTarget && animate) rail.classList.toggle('is-b');
      });
      qsa('[data-kali-vl-rail-heading]', root).forEach(function (h) {
        h.classList.toggle('is-active', h.getAttribute('data-kali-vl-rail-heading') === currentGender);
      });
      var activeRail = qs('[data-kali-vl-rail].is-active', root);
      if (activeRail) {
        if (countEl) countEl.textContent = qsa('[data-kali-vl-pick]', activeRail).length;
        var firstThumb = qs('[data-kali-vl-pick]', activeRail);
        if (firstThumb) selectThumb(firstThumb, true);
      }
    }

    function syncCategoryPanels() {
      categoryPanels.forEach(function (panel) {
        panel.classList.toggle('is-active', panel.getAttribute('data-kali-vl-category-panel') === currentCategory);
      });
    }
    syncCategoryPanels();

    categoryTabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.classList.contains('is-active')) return;
        currentCategory = tab.getAttribute('data-kali-vl-category-tab');
        categoryTabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        syncCategoryPanels();
        updateActiveRail(true);
      });
    });

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        if (tab.classList.contains('is-active')) return;
        tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
        updateActiveRail(true);
      });
    });

    /* FAQ accordion */
    qsa('[data-kali-vl-faq-toggle]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-kali-vl-faq]');
        var wasOpen = item.classList.contains('is-open');
        qsa('[data-kali-vl-faq]', root).forEach(function (i) {
          i.classList.remove('is-open');
          var sign = qs('[data-kali-vl-faq-sign]', i);
          if (sign) sign.textContent = '+';
        });
        if (!wasOpen) {
          item.classList.add('is-open');
          var sign = qs('[data-kali-vl-faq-sign]', item);
          if (sign) sign.textContent = '−';
        }
      });
    });
  })();

  /* ---------- Home: "¿Para quién estás comprando?" audience filter ---------- */
  (function audienceFilter() {
    var roots = qsa('[data-kali-audience-root]');
    if (!roots.length) return;

    roots.forEach(function (root) {
      var btns = qsa('[data-kali-audience-btn]', root);
      var cards = qsa('[data-kali-audience-tags]', root);
      var notes = qsa('[data-kali-audience-note-for]', root);
      if (!btns.length) return;

      function apply(key) {
        btns.forEach(function (b) {
          b.classList.toggle('is-active', b.getAttribute('data-kali-audience-btn') === key);
        });
        cards.forEach(function (c) {
          var tags = c.getAttribute('data-kali-audience-tags').split(',');
          var show = key === 'todos' || tags.indexOf(key) !== -1;
          c.hidden = !show;
        });
        notes.forEach(function (n) {
          n.hidden = n.getAttribute('data-kali-audience-note-for') !== key;
        });
        var grid = root.querySelector('.kali-audience-grid');
        if (grid) grid.scrollLeft = 0;
      }

      btns.forEach(function (b) {
        b.addEventListener('click', function () {
          apply(b.getAttribute('data-kali-audience-btn'));
        });
      });
    });
  })();

  /* ---------- Home: little confetti burst (bestsellers celebration) ---------- */
  function kaliConfetti(anchor) {
    var host = anchor.parentElement;
    if (!host) return;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var COLORS = ['#0f9d58', '#2fd07a', '#f2b134', '#2f5aa8', '#8a4f6d', '#8ef2b4'];
    for (var i = 0; i < 14; i++) {
      var p = document.createElement('span');
      var round = i % 3 === 0;
      p.style.cssText = [
        'position:absolute',
        'left:' + (anchor.offsetLeft + anchor.offsetWidth * 0.35) + 'px',
        'top:' + (anchor.offsetTop + anchor.offsetHeight * 0.35) + 'px',
        'width:' + (round ? 6 : 4) + 'px',
        'height:' + (round ? 6 : 8) + 'px',
        'border-radius:' + (round ? '999px' : '1px'),
        'background:' + COLORS[i % COLORS.length],
        'pointer-events:none', 'opacity:1', 'z-index:3',
        'transition:transform .9s cubic-bezier(.16,.84,.44,1),opacity .9s ease'
      ].join(';');
      host.appendChild(p);
      (function (p) {
        var ang = (-140 + Math.random() * 100) * (Math.PI / 180);
        var dist = 40 + Math.random() * 55;
        requestAnimationFrame(function () {
          p.style.transform = 'translate(' + Math.cos(ang) * dist + 'px,' + (Math.sin(ang) * dist + 28) + 'px) rotate(' + (Math.random() * 420 - 210) + 'deg)';
          p.style.opacity = '0';
        });
        setTimeout(function () { p.remove(); }, 1100);
      })(p);
    }
  }

  /* ---------- Home: animated unit counters (bestsellers) ----------
     Triggered by scroll position (IntersectionObserver) so the count-up plays
     right when the section comes into view, with a safety-net timer as a
     fallback for the rare browser without IntersectionObserver support. */
  (function bestsellerAnims() {
    var countEls = qsa('[data-kali-count]');
    if (!countEls.length) return;

    var fmt = function (n) { return n.toLocaleString('es-CO'); };

    function countUp(el) {
      if (el.dataset.kaliCounted) return;
      el.dataset.kaliCounted = '1';
      var target = parseInt(el.getAttribute('data-kali-count'), 10) || 0;
      var dur = 2600;
      var t0 = performance.now();
      var isParty = el.hasAttribute('data-kali-party');
      function step(t) {
        var k = Math.min(1, (t - t0) / dur);
        var eased = 1 - Math.pow(1 - k, 3);
        el.textContent = fmt(Math.round(target * eased));
        if (k < 1) { requestAnimationFrame(step); return; }
        el.textContent = fmt(target);
        if (!isParty) return;
        el.style.transition = 'transform .3s cubic-bezier(.34,1.56,.64,1),color .6s ease';
        el.style.transform = 'scale(1.18)';
        el.style.color = '#0f9d58';
        setTimeout(function () { el.style.transform = 'scale(1)'; }, 200);
        setTimeout(function () { el.style.color = ''; }, 700);
        kaliConfetti(el);
      }
      requestAnimationFrame(step);
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          countUp(entry.target);
          io.unobserve(entry.target);
        });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });

      /* Don't start observing until the user has actually scrolled: on tall
         viewports these sections can already sit inside the initial viewport,
         which made the observer fire immediately on page load instead of on
         scroll. Arming it only after a real scroll event guarantees the
         count-up genuinely happens in response to scrolling. */
      function arm() { countEls.forEach(function (el) { io.observe(el); }); }
      if (window.scrollY > 40) {
        arm();
      } else {
        window.addEventListener('scroll', function onFirstScroll() {
          window.removeEventListener('scroll', onFirstScroll);
          arm();
        }, { passive: true, once: true });
      }
    } else {
      countEls.forEach(countUp);
    }

    /* Safety net: if for any reason the observer never fires for an element
       (odd layout, very short page, etc.), don't leave it stuck at 0. */
    setTimeout(function () {
      countEls.forEach(countUp);
    }, 9000);
  })();

  /* ---------- Home: infinite scrolling review columns ----------
     Reads real Judge.me reviews out of the [hidden] data source the section
     renders (see kali-home-testimonials.liquid) and builds our own cards +
     vertical auto-scroll loop, entirely independent of Judge.me's carousel
     engine — it owns its own slides' box model to make its slider math work,
     so trying to re-skin it directly broke twice (see git history). */
  (function homeTestiColumns() {
    var source = qs('[data-kali-testi-source]');
    var columnsRoot = qs('[data-kali-testi-columns]');
    if (!source || !columnsRoot) return;

    var cols = qsa('[data-kali-testi-col]', columnsRoot);
    if (!cols.length) return;

    var itemNodes = qsa('.jdgm-carousel-item', source);
    if (!itemNodes.length) return;

    var reviews = itemNodes.map(function (node) {
      var stars = qsa('.jdgm-star.jdgm--on', node).length;
      var titleEl = qs('.jdgm-carousel-item__review-title', node);
      var bodyEl = qs('.jdgm-carousel-item__review-body', node);
      var nameEl = qs('.jdgm-carousel-item__reviewer-name', node);
      var imgEl = qs('.jdgm-carousel-item__product-image', node);
      var quoteSrc = bodyEl ? bodyEl.textContent : (titleEl ? titleEl.textContent : '');
      return {
        stars: stars || 5,
        quote: quoteSrc.replace(/\s+/g, ' ').trim(),
        name: nameEl ? nameEl.textContent.replace(/\s+/g, ' ').trim() : '',
        img: imgEl ? (imgEl.getAttribute('data-src') || imgEl.getAttribute('src')) : null
      };
    }).filter(function (r) { return r.quote && r.name; });

    if (!reviews.length) return;

    function buildCard(review) {
      var card = document.createElement('div');
      card.className = 'kali-home-testi-card';

      var starsEl = document.createElement('div');
      starsEl.className = 'kali-home-testi-card-stars';
      for (var i = 1; i <= 5; i++) {
        var s = document.createElement('span');
        if (i <= review.stars) s.className = 'is-on';
        s.textContent = i <= review.stars ? '★' : '☆';
        starsEl.appendChild(s);
      }
      card.appendChild(starsEl);

      var quoteEl = document.createElement('p');
      quoteEl.className = 'kali-home-testi-card-quote';
      quoteEl.textContent = '“' + review.quote + '”';
      card.appendChild(quoteEl);

      var authorEl = document.createElement('div');
      authorEl.className = 'kali-home-testi-card-author';

      if (review.img) {
        var avatar = document.createElement('img');
        avatar.className = 'kali-home-testi-card-avatar';
        avatar.src = review.img;
        avatar.alt = review.name;
        avatar.loading = 'lazy';
        authorEl.appendChild(avatar);
      } else {
        var fallback = document.createElement('span');
        fallback.className = 'kali-home-testi-card-avatar-fallback';
        fallback.textContent = review.name.slice(0, 2);
        authorEl.appendChild(fallback);
      }

      var nameEl2 = document.createElement('div');
      nameEl2.className = 'kali-home-testi-card-name';
      nameEl2.textContent = review.name;
      authorEl.appendChild(nameEl2);

      card.appendChild(authorEl);
      return card;
    }

    var durations = [34, 42, 38];
    cols.forEach(function (col, colIndex) {
      var colReviews = reviews.filter(function (_, i) { return i % cols.length === colIndex; });
      if (!colReviews.length) colReviews = reviews;

      var track = document.createElement('div');
      track.className = 'kali-home-testi-col-track';
      track.style.setProperty('--kali-testi-duration', durations[colIndex % durations.length] + 's');

      /* Duplicated once so translateY(-50%) lands on an identical frame —
         the loop reads as continuous, infinite scroll instead of a hard cut. */
      colReviews.concat(colReviews).forEach(function (review) {
        track.appendChild(buildCard(review));
      });

      col.appendChild(track);
    });
  })();

  /* ---------- Home: launch hero category slideshow ---------- */
  (function heroCategorySlideshow() {
    var roots = qsa('[data-kali-hero-slideshow]');
    if (!roots.length) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    roots.forEach(function (root) {
      var slides = qsa('[data-kali-hero-slide]', root);
      var dots = qsa('[data-kali-hero-dot]', root);
      if (slides.length < 2) return;

      var section = root.closest('.kali-launch-hero-section') || document;
      var badgeTexts = qsa('[data-kali-hero-badge-text]', section);
      var featsSets = qsa('[data-kali-hero-feats-set]', section);
      var titleTexts = qsa('[data-kali-hero-title-text]', section);
      var descTexts = qsa('[data-kali-hero-desc-text]', section);
      var ctaLink = qs('[data-kali-hero-cta]', section);
      var ctaLabel = qs('[data-kali-hero-cta-label]', section);

      function toggleStack(list, index) {
        list.forEach(function (el, i) {
          var active = i === index;
          el.classList.toggle('is-active', active);
          if (active) el.removeAttribute('aria-hidden');
          else el.setAttribute('aria-hidden', 'true');
        });
      }

      var current = 0;
      var timer;

      function show(index) {
        current = (index + slides.length) % slides.length;
        slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === current); });
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === current); });
        toggleStack(badgeTexts, current);
        toggleStack(featsSets, current);
        toggleStack(titleTexts, current);
        toggleStack(descTexts, current);

        if (ctaLink) {
          var activeSlide = slides[current];
          ctaLink.setAttribute('href', activeSlide.getAttribute('href') || '#');
          if (ctaLabel) {
            var tag = activeSlide.getAttribute('data-kali-hero-tag') || 'categoría';
            ctaLabel.classList.add('is-swapping');
            setTimeout(function () {
              ctaLabel.textContent = 'Ver ' + tag;
              ctaLabel.classList.remove('is-swapping');
            }, 220);
          }
        }
      }

      function start() {
        if (reduceMotion) return;
        clearInterval(timer);
        timer = setInterval(function () { show(current + 1); }, 3800);
      }

      function stop() {
        clearInterval(timer);
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          show(i);
          start();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', start);

      start();
    });
  })();
})();
